import { AxiosPromise } from 'axios';
import { axiosnginrMessenger } from 'src/app/utils';

import { urlsConfig } from 'src/configs';
import { serviceNginrMessengerTypes } from 'src/types';
import { NginrMessengerServiceGetPublicKeyResultType } from 'src/types/services/nginr/nginr-messenger-service.type';

export const createCredentials = (
  credentialInformation: serviceNginrMessengerTypes.NginrMessengerServiceCredentialCreateType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceNginrMessengerTypes.NginrMessengerServiceCredentialResultType> => {
  return axiosnginrMessenger.post(urlsConfig.messenger.createCredentials, credentialInformation, options);
};

export const sendEmail = (
  emailInformation: serviceNginrMessengerTypes.NginrMessengerServiceMailCreateResultType,
): AxiosPromise<serviceNginrMessengerTypes.NginrMessengerServiceGetPublicKeyResultType> => {
  return axiosnginrMessenger.post(urlsConfig.messenger.createMail, emailInformation, {
    headers: {
      'Content-Type': 'text/plain; charset=utf-8',
    },
  });
};

export const getPublicKey = (
  emailInformation: serviceNginrMessengerTypes.NginrMessengerServiceGetPublicKeyType,
): AxiosPromise<NginrMessengerServiceGetPublicKeyResultType> => {
  return axiosnginrMessenger.post(urlsConfig.messenger.getPublicKey, emailInformation);
};

export const createUserPassword = (
  createUserPassword: serviceNginrMessengerTypes.NginrMessengerServiceCreateUserPassword,
): AxiosPromise<NginrMessengerServiceGetPublicKeyResultType> => {
  return axiosnginrMessenger.post(urlsConfig.messenger.createUserPassword, createUserPassword);
};
